export const devEnv = window.location.host.includes('localhost') || window.location.host.includes('landing-dev') || window.config?.NODE_ENV === 'development';
export const PATH_SERVER = window.config?.REACT_APP_PATH_SERVER;
